<template>
    <section class="blog my-5">
        <div class="container">
            <div class="row">
                <!-- <div class="col-md-4" v-for="(item,index) in 6" :key="index" v-if="!blogs">
                    <content-loader :height="290" :speed="2" :animate="true"></content-loader>
                </div> -->
                <div class="col-md-4" v-for="(item,index) in blogs" :key="index">
                    <list-blog :img="item.img" :title="item.title" :fullname="item.fullname" :pub_date="item.pub_date" :id="item.id" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import listBlog from 'cp/blog/list.vue'
export default {
    name: 'blog',
    components: {
        listBlog
    },
    mounted () {
        this.getBlog(1)
    },
    computed: {
        blogs () {
            return this.$store.state.blog.listBlog || null
        }
    },
    methods: {
        getBlog (p) {
            this.$store.dispatch('blog/getListBlog', { page_num: p })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/blog/index.vue